/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_CancelInputs */

const vi_api_keys_cancel = /** @type {(inputs: Api_Keys_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy`)
};

/**

* @param {Api_Keys_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_cancel = /** @type {((inputs?: Api_Keys_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_cancel(inputs)
});